<script setup lang="ts">
function extractDate(path?: string): string | null {
  const match = path?.match(/(\d{4}\/\d{2}\/\d{2})/);
  if (match) {
    return match[1];
  }
  return null;
}
</script>

<template>
  <main class="mx-2rem sm:w-lg sm:mx-auto">
    <ContentDoc>
      <template #default="{ doc }">
        <article>
          <ContentRenderer :value="doc" />
          <p class="pt-1.5rem" v-if="extractDate(doc._path)"><em>
              Written on {{ extractDate(doc._path) }}</em></p>
        </article>
        <!-- <div id="cusdis_thread" data-host="https://cusdis.com" data-app-id="c5419baf-9daa-4343-8c82-03f3addd7c1a"
          :data-page-id=doc._path :data-page-url=$route.path :data-page-title=doc.title></div> -->
        <!-- <ClientOnly>
          <component :is="'script'" async defer src="https://cusdis.com/js/cusdis.es.js">
          </component>
        </ClientOnly> -->
      </template>
      <template #not-found>
        <h1>404 NOT FOUND</h1>
        <p>You reached this catch all route, which is unexpected.</p>
      </template>
    </ContentDoc>
  </main>
  <Footer />
</template>

<style lang="scss">
article h1 {
  text-transform: uppercase;
  font-size: 2.5rem;
}

article h2 {
  text-transform: capitalize;
}

article p {
  overflow-x: clip;
}

article p img {
  max-width: 100%;
  height: auto;
}

article>div>* {
  margin-bottom: 1rem;
}

article li {
  font-size: 1rem;
}
</style>
